import { xget, xhttp } from "../Fetchv2.js";
import { PGSchema } from "../schemas/pg.schema.js";

export class SESv2API {
	/**
	 * @path /pages/:pgid/ses
	 * @param pgid - Page ID
	 * @param token - Token
	 * @param query - Query parameters (take, skip, job_id, uid)
	 */
	async getAllUsersSES(pgid: string, token: string, query?: { take?: number; skip?: number; job_id?: string; uid?: string }) {
		return xget<{
			results: PGSchema.users_ses[];
			positions: PGSchema.jobs[];
			users: PGSchema.users[];
		}>(`/pages/${pgid}/ses`, query || {}, {
			headers: { "app-token": token }
		});
	}

	async getSES(pgid: string, sesId: string) {
		return xget<{ ses: PGSchema.users_ses; position: PGSchema.jobs; user: PGSchema.users }>(
			`/pages/${pgid}/ses/${sesId}`,
			{},
			{
				headers: {}
			}
		);
	}

	/**
	 * @path /pages/:pgid/ses
	 * @param pgid - Page ID
	 * @param data - Users SES data (must include pgid and job_id)
	 * @param token - Token
	 */
	async createUsersSES(pgid: string, data: Partial<PGSchema.users_ses>, token: string) {
		return xhttp<{
			ses: PGSchema.users_ses;
			user: PGSchema.users;
			position: PGSchema.jobs;
		}>(`/pages/${pgid}/ses`, "POST", data, {
			headers: { "app-token": token }
		});
	}

	/**
	 * @path /pages/:pgid/ses/:ses_id/link
	 * @param pgid - Page ID (used as job_id in backend)
	 * @param sesId - SES ID
	 * @param url - URL to link
	 */
	async updateSESLink(pgid: string, sesId: string, url: string) {
		return xhttp<PGSchema.users_ses>(`/pages/${pgid}/ses/${sesId}/link`, "POST", { url }, {});
	}

	/**
	 * @path /pages/:pgid/ses/:tid
	 * @param pgid - Page ID (used as job_id in backend)
	 * @param tid - SES ID to delete
	 * @param token - Token
	 */
	async deleteUsersSES(pgid: string, tid: string, token: string) {
		return xhttp<{ ok: boolean; message: string }>(
			`/pages/${pgid}/ses/${tid}`,
			"DELETE",
			{},
			{
				headers: { "app-token": token }
			}
		);
	}

	/**
	 * @path /pages/:pgid/ses/:ses_id/link
	 * @param pgid - Page ID (used as job_id in backend)
	 * @param sesId - SES ID
	 * @param url - URL to link
	 */
	async updateSES(pgid: string, sesId: string, data: Partial<PGSchema.users_ses["ses"]>) {
		return xhttp<PGSchema.users_ses>(`/pages/${pgid}/ses/${sesId}/ses`, "POST", data, {});
	}
}
